import type { LabeledOption, ProductCategory } from '@iheartjane/types';

export type CustomLineageLabels = Partial<Record<ProductCategory, string>>;

export const lineageOptions = (
  labels: CustomLineageLabels = {}
): LabeledOption[] => {
  const {
    indica = 'Indica',
    sativa = 'Sativa',
    hybrid = 'Hybrid',
    cbd = 'CBD',
  } = labels;

  return [
    {
      value: 'indica',
      label: indica,
    },
    {
      value: 'sativa',
      label: sativa,
    },
    {
      value: 'hybrid',
      label: hybrid,
    },
    {
      value: 'cbd',
      label: cbd,
    },
  ];
};
